export interface GetVesselsResponse {
    count: number;
    result: VesselModel[];
}

export class VesselModel {
    vesselId: number;
    vesselName: string;
    identifier: string;
    dwt?: number;
    vesselType?: string;
    internationalMaritimeOrganizationNumber?: string;
    vehicleIdentificationNumber?: string;
    europeanNumberOfIdentification?: string;
    maritimeMobileServiceIdentityNumber?: string;
    isLoading?: boolean;
    isSelected?: boolean;
    typeGroupId? : number;
    typeGroupName: string;
    isMonitored:boolean;
}